import { render, staticRenderFns } from "./PfHome.vue?vue&type=template&id=cacfaba0&"
import script from "./PfHome.vue?vue&type=script&lang=js&"
export * from "./PfHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports